import {SmartComponent} from "smart-component-js";

class CardInfoCarComponent extends SmartComponent {

    constructor(element, parentComponent, params) {
        super(element, parentComponent, params);
        this.element = element;
        this.area = this.element.dataset.area || 'privati';
        this.endpoint = `/api/1.0/noleggio/${this.area}`;
        this.init();
    }

    getCars() {
        return youserxp.ajax(this.endpoint, {method: 'GET', auth: false}).then(
            (data) => {
                this.cars = data.body;
                this.appendCars();
            },
            (err) => console.log(err)
        );
    }

    appendCars() {
        let items = '';
        this.cars.forEach((item) => {
            items += `
            <div class="single-card-car full-image">
                <img src=${item.image} alt="image" class="single-card__image"/> 
                  <div class="single-card-car__price">
                    <h3 class="single-card-car__price-article ">${item.price}</h3>
                    <span>al mese ${this.area === 'privati' ? 'Iva inclusa' : 'Iva esclusa'}</span>
                </div>
                 <h5 class="single-card__title-card green">${item.name}</h5>
                <div class="single-card__description green">
                    ${item.description}
                </div>
                <div class="single-card-car__info-car">
                <span class="green">Durata <strong>${item.duration}</strong></span>
                <span class="green">Chilometraggio totale <strong>${item.totalMileage}</strong></span>
                <span class="green">Anticipo <strong>${item.advancePayment}</strong> ${this.area === 'privati' ? 'Iva inclusa' : 'Iva esclusa'}</span>
                </div>
            </div>`
        })
        this.element.innerHTML = `<div class="container-flex-row">` + items + `</div>`
    }

    init() {
        this.getCars();
        document.addEventListener("yxp-form-options-service-ok", (el) => {
            const inputAgencyEmail = document.querySelector('form select[name="agencyEmail"]');
            if(inputAgencyEmail){
            inputAgencyEmail.selectedIndex = 1;
            console.log("form", el);
            }
        })
    }
}

export default CardInfoCarComponent;